import { Logger } from '@nextgen-web-framework/core';
import { type GenericObject } from '../types';
import { logObject } from './loggerUtil';

// eslint-disable-next-line unused-imports/no-unused-vars
type DynamicObject = {
  [key: string]: {
    [key: string]: Array<Record<string, GenericObject>> | Record<string, GenericObject>;
  };
};

type EqualizedObject = {
  [key: string]: GenericObject | string;
};

const loggerInstance = Logger.getInstance(logObject('contentStackApiUtils'));
const connectingStr = '.';

const equalizeData = (cmsData: string, refBlockKey: string): Array<EqualizedObject> => {
  const parsedData: Array<DynamicObject> = JSON.parse(cmsData);
  return parsedData.map((item) => {
    const [[itemKey, itemValue]] = Object.entries(item);
    return {
      ...itemValue,
      parentKeys: [refBlockKey, itemKey].join(connectingStr),
    };
  });
};

const containsLeafNode = (item: Array<EqualizedObject>): boolean => {
  for (const obj of item) {
    for (const property in obj) {
      if (Array.isArray(obj[property])) {
        return true;
      }
    }
  }
  return false;
};

const fetchKeys = (data: Array<EqualizedObject>, keyCollection?: string[], appendedKeys?: string) => {
  data.forEach((entity: EqualizedObject) => {
    const entityKeys = Object.keys(entity);
    for (const entityKey of entityKeys) {
      const newAppendedKeys = [appendedKeys ?? entity.parentKeys, entityKey].join(connectingStr);
      const targetedEntity = entity[entityKey];

      if (Array.isArray(targetedEntity)) {
        if (!containsLeafNode(targetedEntity)) {
          keyCollection?.push(newAppendedKeys);
        }
        fetchKeys(targetedEntity, keyCollection, newAppendedKeys);
      }
    }
  });
};

export const extractKeysFromJson = (data: string, refBlockKey: string): string[] => {
  try {
    const result: string[] = [];
    fetchKeys(equalizeData(data, refBlockKey), result);
    return result;
  } catch (e: unknown) {
    loggerInstance.error('Invalid JSON string. Pleae check for valid JSON string');
    throw new Error(`Invalid JSON string. Please retry with valid JSON string. ${e}`);
  }
};
